var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material Symbols and Icons (1). 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4375 13.7884H9.56246V10.4624L10.95 11.8499L11.7404 11.048L8.99998 8.30768L6.25961 11.048L7.06151 11.8384L8.4375 10.4624V13.7884ZM4.73077 16.125C4.35193 16.125 4.03125 15.9937 3.76875 15.7312C3.50625 15.4687 3.375 15.148 3.375 14.7692V3.23078C3.375 2.85193 3.50625 2.53125 3.76875 2.26875C4.03125 2.00625 4.35193 1.875 4.73077 1.875H10.6875L14.625 5.81246V14.7692C14.625 15.148 14.4937 15.4687 14.2312 15.7312C13.9687 15.9937 13.648 16.125 13.2692 16.125H4.73077ZM10.125 6.37496V2.99998H4.73077C4.67308 2.99998 4.62018 3.02402 4.57209 3.07209C4.52402 3.12018 4.49998 3.17308 4.49998 3.23078V14.7692C4.49998 14.8269 4.52402 14.8798 4.57209 14.9279C4.62018 14.9759 4.67308 15 4.73077 15H13.2692C13.3269 15 13.3798 14.9759 13.4279 14.9279C13.4759 14.8798 13.5 14.8269 13.5 14.7692V6.37496H10.125Z",
    fill: "#2196F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.ad1f49139604dc3737b61dcb942ccec7.svg";
export { ForwardRef as ReactComponent };